<template>
  <div class="article-single__content-editor comment-box">
    <div class="comment-wrapper">
      <h2>What do you think?</h2>
      <ToggleButton
        class="discussion-toggle"
        :value="article.thread.notify_new_comment"
        @update:value="updateToggle"
      >
        Notify me of new comments in this discussion
      </ToggleButton>
      <CommentEdit ref="commentEdit" :doc="article" :thread="article.thread" />
    </div>
    <Comments :doc="article" :thread="article.thread" />
  </div>
</template>

<script setup lang="ts">
import type { ArticleView } from '@/models/doc.article'

import Comments from '@/app/components/community/Comments.vue'
import CommentEdit from '@/app/components/community/CommentEdit.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import { ThreadView } from '@/models/forum'

const props = defineProps<{
  article: ArticleView
}>()

async function updateToggle(value: boolean): Promise<void> {
  await new ThreadView(
    props.article.thread,
    props.article,
  ).toggleNotifyNewComment(value)
}
</script>
